/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class BuzzerBridgeCallsAPI extends ApiClient {
  constructor() {
    super('buzzer_bridge_calls', { accountScoped: true });
  }

  initiate({ conversationId, contactId, phoneNumber, inboxId, clientRef }) {
    return axios
      .post(this.url, {
        conversation_id: conversationId,
        contact_id: contactId,
        phone_number: phoneNumber,
        inbox_id: inboxId,
        client_ref: clientRef,
      })
      .then(response => response.data);
  }

  pending() {
    return axios.get(this.url).then(response => response.data);
  }

  ready(callId) {
    return axios.post(`${this.url}/${callId}/ready`);
  }

  report(callId, { status, endReason = null, durationSeconds = null }) {
    return axios.patch(`${this.url}/${callId}`, {
      status,
      end_reason: endReason,
      duration_seconds: durationSeconds,
    });
  }
}

export default new BuzzerBridgeCallsAPI();
